// Copyright (c) 2022 by Move Closer

import { ComponentObjectPropsOptions, Emit } from '../../vue-api'

import { DrawerInnerProps, UseDrawerInnerProvides } from './DrawerInner.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const drawerInnerProps: ComponentObjectPropsOptions<DrawerInnerProps> = {
  /**
   * @see DrawerInnerProps.hasHeader
   */
  hasHeader: {
    type: Boolean,
    required: false,
    default: true
  },

  /**
   * @see DrawerInnerProps.title
   */
  title: {
    type: String,
    required: false
  }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const useDrawerInner = (props: DrawerInnerProps, emit: Emit): UseDrawerInnerProvides => {
  /**
   * Emits close event
   */
  const close = () => {
    emit('close')
  }

  return { close }
}
